// extracted by mini-css-extract-plugin
export var button = "_ei-4";
export var hasDarkBackground = "_ei-7";
export var hasLightBackground = "_ei-6";
export var iconWrapper = "_ei-0";
export var large = "_ei-2";
export var medium = "_ei-1";
export var small = "_ei-5";
export var xsmall = "_ei-3";